/**
 * Starts the browser download of a file the backend has already written, by
 * following its URL through a throwaway link.
 */
export const openDownloadUrl = (url: string): void => {
  const a = document.createElement("a");
  a.href = url;
  a.click();
  a.remove();
};
